<script>
    export let organizations;
</script>
<div class="modal fade" id="organizationsListModal" tabindex="-1" role="dialog" aria-labelledby="editSection" aria-hidden="true">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    Organizations List
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {#if organizations}
                    <div class="modal-table-content">
                        <table class="table container-fluid">
                            <thead>
                                <tr class="bg-dark text-light">
                                    <th>ID</th>
                                    <th>Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {#each organizations as org}
                                    <tr>
                                        <td>{ org.id }</td>
                                        <td>{ org.name }</td>
                                    </tr>
                                {/each}
                            </tbody>
                        </table>
                    </div>
                {/if}
            </div>
        </div>
    </div>
</div>